import { handleActions } from "redux-actions";
import { SHIPPING_RATES } from "constants/action-types";
import { fetchActions, initialBaseState } from "./base-reducers";
import type { IShippingRatesState } from "types/shipping";

export const shippingRates = handleActions<IShippingRatesState>(
    fetchActions(SHIPPING_RATES.FETCH) as any,
    initialBaseState,
);
